import { currentJob } from './current_job';
import { Pagination } from 'packages/core/Pagination';
import { Pipeline } from 'packages/v3/pipeline/Pipeline';
import { Job } from 'packages/v3/jobs/Job';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
export var types = {
    SET_JOB: 'setJob',
    SET_JOBS: 'setJobs',
    SET_STARRED_JOBS: 'setStarredJobs',
    SET_LOADING: 'setLoading',
    SET_PAGINATION: 'setPagination',
    APPEND_CANDIDATES_FOR_CURRENT_JOB: 'appendCandidatesToForCurrentJob',
    SET_PIPELINE: 'setPipeline',
    UPDATE_CANDIDATE: 'updateCandidate',
    SET_CANDIDATES: 'setCandidates',
    SET_QUERY_FILTERS: 'setQueryFilters',
    SET_RESULT_SCREEN_FILTERS: 'setResultScreenFilters',
    SET_TARGET_URL: 'setTargetUrl',
    SET_JOB_AS_STARRED: 'setJobAsStarred',
    UNSET_JOB_AS_STARRED: 'unsetJobAsStarred',
};
export var state = {
    jobs: [],
    starredJobs: [],
    job: new Job(),
    targetUrl: null,
    loading: false,
    pagination: new Pagination(),
    candidates: [],
    candidate: null,
    pipeline: new Pipeline(),
    queryFilters: null,
    resultScreenFilters: [],
    pipelineValidity: { valid: true, invalidStages: [] },
};
export var jobs = {
    namespaced: true,
    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations,
    modules: {
        currentJob: currentJob,
    },
};
